{
  "notifications": {
    "eyebrow": "Account",
    "title": "Notifications",
    "subtitle": "Manage how BidNova reaches you about bids, wins and shipments.",
    "notFound": "Not found.",
    "pageTitle": "Notification settings — BidNova Auctions"
  },
  "bell": {
    "ariaUnread": "Notifications, {count} unread",
    "ariaNoUnread": "Notifications",
    "title": "Notifications",
    "unreadCount": "{count} unread",
    "allCaughtUp": "You're all caught up",
    "markAllRead": "Mark all read",
    "empty": "No notifications yet.",
    "settingsLink": "Notification settings",
    "defaultTitle": "Notification",
    "timeJustNow": "just now",
    "timeMinutes": "{count}m ago",
    "timeHours": "{count}h ago",
    "timeDays": "{count}d ago",
    "timeWeeks": "{count}w ago",
    "toastMarkOneError": "Could not mark as read",
    "toastMarkAllError": "Could not mark all as read",
    "toastMarkAllSuccess": "All caught up"
  },
  "prefs": {
    "eyebrow": "Notifications",
    "subtitle": "Choose how you want to hear from BidNova.",
    "enableGlobalPush": "Enable browser push globally",
    "addDevice": "Add this device",
    "sendTest": "Send test",
    "categoriesHeading": "Categories",
    "eventsHeading": "Event",
    "colInApp": "In-app",
    "colEmail": "Email",
    "colPush": "Push",
    "devicesHeading": "Devices",
    "noDevices": "No push devices registered yet.",
    "removeDevice": "Remove device",
    "failures": "{count} fails",
    "toastPushNotConfigured": "Push not configured yet.",
    "toastPushDenied": "Push permission denied.",
    "toastPushEnabled": "Push notifications enabled on this device",
    "toastTestSent": "Test notification sent ({count} channels)",
    "category": {
      "pushMaster": "Master push toggle",
      "auctionOutbid": "Auction outbid",
      "auctionWon": "Auction won",
      "auctionLost": "Auction lost",
      "endingSoon": "Ending soon",
      "paymentReceived": "Payment received",
      "paymentReleased": "Payment released",
      "sellerMessage": "Seller messages",
      "buyerMessage": "Buyer messages",
      "systemUpdates": "System updates",
      "securityAlerts": "Security alerts",
      "weeklySummary": "Weekly summary",
      "marketing": "Marketing (opt-in)"
    },
    "event": {
      "endingSoon": "Auction ending soon",
      "priceDrop": "Price drop / Buy-It-Now change",
      "wantMatch": "Want-list match found",
      "outbid": "You were outbid",
      "auctionWon": "Auction won",
      "auctionLost": "Auction lost",
      "reserveMet": "Reserve met",
      "paymentRequired": "Payment required",
      "paymentReceived": "Payment received",
      "dispatchRequired": "Seller dispatch required",
      "itemDispatched": "Item dispatched",
      "trackingUpdate": "Royal Mail tracking update",
      "deliveryConfirm": "Delivery confirmation",
      "payoutReleased": "Payout released",
      "disputeUpdate": "Dispute update",
      "promotionActivated": "Featured promotion activated",
      "reservationExpiring": "Buy-It-Now reservation expiring",
      "watchlistNewBid": "New bid on a watched auction",
      "auctionBelowReserve": "Your auction ended below reserve",
      "refundCompleted": "Refund completed",
      "listingApproved": "Listing approved",
      "listingRejected": "Listing needs changes"
    }
  },
  "watchlist": {
    "pageTitle": "Watchlist",
    "eyebrow": "Buyer",
    "title": "Watchlist",
    "subtitle": "Cards you're tracking. Bid before they end.",
    "browseAuctions": "Browse auctions",
    "errorDescription": "We couldn't load your watchlist.",
    "emptyTitle": "Your watchlist is empty",
    "emptyDescription": "Browse live auctions and tap the heart to save the ones you love.",
    "discoverCards": "Discover cards"
  },
  "wantList": {
    "pageTitle": "Want List — BidNova Auctions",
    "pageDescription": "Track cards you're hunting for and get matched to active BidNova auctions.",
    "title": "Want List",
    "subtitle": "Track cards you're hunting — we'll flag matching active auctions.",
    "refreshMatches": "Refresh matches",
    "cardName": "Card name *",
    "cardNamePlaceholder": "Charizard",
    "set": "Set",
    "setPlaceholder": "Base Set",
    "maxPrice": "Max price (£)",
    "addButton": "Add to want list",
    "yourWantList": "Your want list",
    "anySet": "any set",
    "active": "active",
    "paused": "paused",
    "pause": "Pause",
    "resume": "Resume",
    "noItemsYet": "No items yet.",
    "matches": "Matches",
    "matched": "Matched {date}",
    "noMatchesYet": "No matches yet — click Refresh matches.",
    "toastAdded": "Added to want list",
    "toastMatchesFound": "Found {count} matches"
  },
  "myBids": {
    "pageTitle": "My Bids",
    "eyebrow": "Buyer",
    "title": "My Bids",
    "errorDescription": "We couldn't load your bids.",
    "emptyTitle": "You haven't placed any bids yet.",
    "emptyDescription": "Find a card you love and place your first bid.",
    "browseAuctions": "Browse auctions",
    "yourBid": "Your bid: {amount}",
    "won": "Won 🎉",
    "ended": "Ended",
    "winning": "Winning",
    "outbid": "Outbid"
  },
  "myAuctions": {
    "pageTitle": "My Auctions",
    "eyebrow": "Seller",
    "title": "My Auctions",
    "subtitle": "Manage your live listings and review past sales.",
    "listACard": "List a card",
    "errorDescription": "We couldn't load your listings.",
    "activeHeading": "Active ({count})",
    "endedHeading": "Ended ({count})",
    "noActiveListings": "No active listings. Create one to get started.",
    "nothingEndedYet": "Nothing ended yet.",
    "bidsCount": "{count} bids",
    "endsOn": "Ends {date}",
    "featuredUntil": "Featured until {date}",
    "extend": "Extend",
    "promote": "Promote"
  },
  "collection": {
    "pageTitle": "Your Collection · BidNova",
    "pageDescription": "Track the cards you own, their acquisition cost, and estimated collection value.",
    "eyebrow": "Collection Manager",
    "title": "Your collection",
    "subtitle": "Track the cards you own separately from what you're selling. Estimated values come from real market data — where market data is unavailable, we show acquisition cost only.",
    "collectionsHeading": "Collections",
    "allItems": "All items",
    "newCollectionPlaceholder": "New collection",
    "noCardsYet": "No cards yet. Create a collection and add your first card.",
    "untitledCard": "Untitled card",
    "quantityShort": "x{count}",
    "acquisitionShort": "acq. {amount}",
    "unarchive": "Unarchive",
    "archive": "Archive",
    "noValuationsYet": "No valuations yet. Estimated values will populate once you run price suggestions on your cards.",
    "cardsLabel": "Cards",
    "acquisitionCostLabel": "Acquisition cost",
    "estimatedValueLabel": "Estimated value",
    "realisedProfitLabel": "Realised profit",
    "addACard": "Add a card",
    "cardNameLabel": "Card name",
    "setLabel": "Set",
    "quantityLabel": "Quantity",
    "acquisitionCostPoundLabel": "Acquisition cost (£)",
    "graded": "Graded",
    "addCardButton": "Add card"
  }
}
